<label *ngIf="isLoading">Loading...</label>

<p-dropdown *ngIf="column && record"
            [options]="options"
            [(ngModel)]="selectedOption"
            [optionLabel]="optionLabelName"
            (ngModelChange)="onModelChange($event)"
            [required]="column.validation?.isRequired === true"
            #ddValue="ngModel"
            id="dropdownEditor"
            [filter]="true"
            filterBy="name"
            [style]="{'width':'100%'}">
  <ng-template pTemplate="filter" let-options="options">
    <input
      type="text"
      pInputText
      placeholder="Search..."
      pAutoFocus
      [autofocus]="true"
      (keyup)="onFilterChanged($event, options)" />
  </ng-template>
</p-dropdown>

<!--<div *ngIf="ddValue.invalid && (ddValue.dirty || ddValue.touched)"
     class="alert">
  <div *ngIf="ddValue.errors?.['required']">
    Required.
  </div>
</div>-->
